// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"105":"53a98be1","124":"6dfee864","177":"b69f9246","319":"0067d91c","579":"24d4311f","965":"71df2c54"}[chunkId] + ".chunk.css";
};